// @flow

import * as React from 'react';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';

import type { CommonActionProps } from './types.actions';
import type { GridItem } from '../../types';
import ToggleController from '../../controllers/ToggleController';
import ButtonAction from './ButtonAction';
import SavedOrdersModule from '../../modules/savedOrders';

type Props = {
  item: GridItem,
};

const SavedOrdersAction = (props: CommonActionProps & Props) => (
  <ToggleController>
    {({ onToggleVisibility, visible }) => (
      <React.Fragment>
        <ButtonAction
          bsSize={props.size}
          disabled={props.disabled}
          onClick={onToggleVisibility}
        >
          <Glyphicon glyph="save-file" /> Saved Orders
        </ButtonAction>
        <Modal bsSize="large" show={visible} onHide={onToggleVisibility}>
          <Modal.Header closeButton>
            <Modal.Title>Saved Orders</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {visible && <SavedOrdersModule isFullPage={false} />}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={onToggleVisibility}>Close</Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    )}
  </ToggleController>
);

SavedOrdersAction.defaultProps = {
  size: 'xsmall',
};

export default SavedOrdersAction;
